<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New Contract</ng-container>
  <ng-container *ngIf="data.id">Edit Contract</ng-container>
</h1>
<mat-dialog-content>

  <aw-contract-form [contract]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-contract-form>

</mat-dialog-content>